import _ from 'lodash';
import moment from 'moment';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { ROW_TYPES } from '../../properties/Properties';
import { useTimezone } from '../../../stores/SessionStore';
import { isBlank } from './Funcs';

function getHoursMinutes(startOrEnd) {
    const separator = ':';
    if (!startOrEnd || startOrEnd.indexOf(separator) < 0) {
        return {
            hour: 0,
            minute: 0,
        };
    }

    const parts = startOrEnd.split(separator);

    return {
        hour: parseInt(parts[0], 10),
        minute: parseInt(parts[1], 10),
    };
}

function leftFillNum(num, targetLength) {
    return num.toString().padStart(targetLength, 0);
}

const convertTime = (hoursMinsStr, fromTz, toTz) => {
    const hoursMins = getHoursMinutes(hoursMinsStr);
    const fromHoursMins = getHoursMinutes(moment().tz(fromTz).format('Z'));
    const toHoursMins = getHoursMinutes(moment().tz(toTz).format('Z'));

    let amPm = 'AM';
    let hour = hoursMins.hour - fromHoursMins.hour + toHoursMins.hour;
    let minute = hoursMins.minute - fromHoursMins.minute + toHoursMins.minute;

    if (minute < 0) {
        minute += 60;
        hour -= 1;
    } else if (minute > 60) {
        minute -= 60;
        hour += 1;
    }
    if (hour < 0) {
        hour += 24;
    } else if (hour > 24) {
        hour -= 24;
    }

    if (hour === 0) {
        hour = 12;
    } else if (hour === 12) {
        amPm = 'PM';
    } else if (hour > 12) {
        amPm = 'PM';
        hour -= 12;
    }
    const tla = moment().tz(toTz).format('z');

    return `${leftFillNum(hour, 2)}:${leftFillNum(minute, 2)} ${amPm} ${tla}`;
};

const RunTime = ({ data }) => {
    const [timezone] = useTimezone();
    const start = _.get(data, 'scheduling.start');
    const fromTz = _.get(data, 'scheduling.timezone') || 'UTC';
    const end = _.get(data, 'scheduling.end');
    return end
        ? `${convertTime(start, fromTz, timezone)} - ${convertTime(end, fromTz, timezone)}`
        : `${convertTime(start, fromTz, timezone)}`;
};

export const runTimeProperty = {
    title: i18n._(t`Run Time`),
    hasValue: (data) => !isBlank(_.get(data, 'scheduling.start')),
    type: ROW_TYPES.FUNCTION,
    mapper: (data) => <RunTime data={data} />,
};
